module.exports = __webpack_public_path__ + "img/teacher04.d68a3279.jpeg";